/**
 * Display phones from react-phone-input-2 (digits + country code, often without "+")
 * as international numbers, e.g. "23051234567" → "+23051234567".
 */
export function formatPhoneDisplay(phone) {
  if (phone == null) return "";
  const raw = String(phone).trim();
  if (!raw) return "";
  if (raw.startsWith("+")) return raw;

  const digits = raw.replace(/[^\d]/g, "");
  if (!digits) return raw;
  return `+${digits}`;
}
